import { Component, OnInit, Input, Output, EventEmitter, Inject } from '@angular/core';
import { FormGroup } from '@angular/forms';

import * as Tokens from '@shared/core/tokens';
import { ILoyaltyAppCountryAssignmentModel } from '@shared/state';
import { Controllers } from '@shared/core';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

@Component({
    selector: 'shared-forms-phone-input',
    templateUrl: './forms-phone-input.shared.component.html',
    styleUrls: ['./forms-phone-input.shared.component.scss']
})
export class FormsPhoneInputComponent implements OnInit {
    public countries$: Observable<ILoyaltyAppCountryAssignmentModel[]>;
    public showCountries$: Observable<boolean>;
    public onSelectUpdateRevalidatedFields: string[] = [];
    @Input() public compact: boolean = false;
    @Input() public parentForm: FormGroup;
    @Input() public label: string;
    @Input() public countryName: string = 'countryPrefix';
    @Input() public mobileName: string = 'cellNumber';
    @Input() public defaultSelected: number;
    @Input() public placeholder!: string;
    /* https://www.countryflags.io/ */
    @Input() public flagSize: 16 | 24 | 32 | 48 | 64 = 24;
    @Input() public flagStyle: 'flat' | 'shiny' = 'shiny';
    @Output() public onButtonClick: EventEmitter<Event> = new EventEmitter();

    constructor(
        @Inject(Tokens.CONFIG_TOKEN) public config: IConfig,
        public controllers: Controllers,
    ) { }

    ngOnInit(): void {
        this.countries$ = this.controllers.appSettings.appGetCounrtries$().pipe(tap(countries => {
            if (this.defaultSelected === undefined) {
                this.defaultSelected = countries.find((c) => c.IsDefault)?.Id || 222;
            }
        }));
        this.showCountries$ = this.controllers.appSettings.appGetCounrtries$().pipe(
            map(countries => countries.length > 0 && this.parentForm !== undefined && this.parentForm.controls[this.countryName] !== undefined)
        );

        if (!this.parentForm) {
            return console.warn('parentForm not provided in forms-phone-input component', this.parentForm);
        }
        if (!this.parentForm.controls[this.countryName]) {
            console.warn(`form control "${this.countryName}" doesn't exist in provided 'parentForm' instance:`, this.parentForm,
                'This component can accept string "countryName" property to adjust control name');
        }

        if (!this.parentForm.controls[this.mobileName]) {
            console.warn(`form control "${this.mobileName}" doesn't exist in provided 'parentForm' instance:`, this.parentForm,
                'This component can accept string "mobileName" property to adjust control name');
        }

        this.onSelectUpdateRevalidatedFields.push(this.mobileName);

        if (!this.placeholder) {
            this.placeholder = '';
        }
    }

    public handleErrorButtonClick($event: Event): void {
        this.onButtonClick.emit($event);
    }
}
